import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CollectsAnalyticsQuery, CollectsSnapshotResponse, CollectsDistributionResponse, CollectsTrendsResponse, CollectsGeoResponse } from './collects-analytics.model';
import { CollectsAnalyticsService } from './collects-analytics.abstract.service';

@Injectable({
    providedIn: 'root',
})
export class CollectsAnalyticsImplService implements CollectsAnalyticsService {
    private baseUrl = `${environment.API_GATEWAY_URL}/service-state/admin/collect/analytics`;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    getSnapshot(query: CollectsAnalyticsQuery): Observable<CollectsSnapshotResponse> {
        return this.http.get<CollectsSnapshotResponse>(`${this.baseUrl}/snapshot`, {
            params: this.buildParams(query),
        });
    }

    getDistribution(query: CollectsAnalyticsQuery): Observable<CollectsDistributionResponse> {
        return this.http.get<CollectsDistributionResponse>(`${this.baseUrl}/distribution`, {
            params: this.buildParams(query),
        });
    }

    getTrends(query: CollectsAnalyticsQuery): Observable<CollectsTrendsResponse> {
        return this.http.get<CollectsTrendsResponse>(`${this.baseUrl}/trends`, {
            params: this.buildParams(query),
        });
    }

    getGeo(query: CollectsAnalyticsQuery): Observable<CollectsGeoResponse> {
        return this.http.get<CollectsGeoResponse>(`${this.baseUrl}/geo`, {
            params: this.buildParams(query),
        });
    }

    private buildParams(query: CollectsAnalyticsQuery): HttpParams {
        let params = new HttpParams();

        if (query.period) {
            params = params.set('period', query.period);
        }
        if (query.from) {
            params = params.set('from', query.from);
        }
        if (query.to) {
            params = params.set('to', query.to);
        }
        if (query.comparePrevious) {
            params = params.set('comparePrevious', 'true');
        }
        if (query.areaId) {
            params = params.set('areaId', query.areaId);
        }

        return params;
    }
}

export const COLLECTS_ANALYTICS_SERVICE_PROVIDER = {
    provide: CollectsAnalyticsService,
    useClass: CollectsAnalyticsImplService,
};
